import {
  MenuRoot,
  Typography,
  Divider,
  Box,
  MenuContent,
  MenuItem,
  MenuTrigger,
  Show,
} from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import { Nullable } from 'shared_DEPRECATED/types';

import { useCoachSettingsEnabled } from 'features/coach/settings/hooks';

import { MenuTriggerButton } from './MenuTriggerButton';

type HeaderMenuContentProps = {
  navigateToSettingsPage: () => void;
  handleLogout: () => void;
  name: string;
  email: Nullable<string>;
  profileUrl: string;
  children: React.ReactNode;
};

export const HeaderMenuContent = ({
  navigateToSettingsPage,
  handleLogout,
  name,
  email,
  profileUrl,
  children,
}: HeaderMenuContentProps) => {
  const isCoachProfileFormPageDisabled = useCoachSettingsEnabled();

  return (
    <MenuRoot>
      <MenuTrigger as="span">
        <MenuTriggerButton
          name={name}
          pictureUrl={profileUrl}
          dataTestId="UserMenu_popoverButton"
        />
      </MenuTrigger>
      <MenuContent>
        <Show when={!!email}>
          <Box p="12px 8px">
            <Typography
              textAlign="center"
              type="meta"
              color="gray"
              fontWeight="medium"
            >
              {email}
            </Typography>
          </Box>
        </Show>
        {children}
        <Divider orientation="horizontal" />
        <Show when={!isCoachProfileFormPageDisabled}>
          <MenuItem
            onClick={navigateToSettingsPage}
            gap={2}
            h={12}
            data-testid="UserMenuOptionButton_profileSettings"
          >
            <Icon name={iconNames.settings} width="18px" />
            <Typography type="body" fontWeight="medium" color="black">
              Settings
            </Typography>
          </MenuItem>
        </Show>
        <MenuItem
          onClick={handleLogout}
          gap={2}
          h={12}
          data-testid="UserMenuOptionButton_logOut"
        >
          <Icon name={iconNames.logout} width="24px" />
          <Typography type="body" fontWeight="medium" color="black">
            Log out
          </Typography>
        </MenuItem>
      </MenuContent>
    </MenuRoot>
  );
};
